import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'; 
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-design-notes',
  templateUrl: './design-notes.component.html',
  styleUrls: ['./design-notes.component.less']
})
export class DesignNotesComponent implements OnInit {

 @Input() roomId = 402554;
 @Input() isHandset: boolean;
 @Output() scrollTop = new EventEmitter<void>();

  noteBody = '';
  isPrivate = false;
  notes: any[] = [];
  isSubmitting = false;
  noteId: any;
  isLoading: boolean;
  userType: any;

  constructor(private notesService: ApiService,private snackbar:MatSnackBar) {}

  ngOnInit(): void {
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;

    this.loadNotes();
  }

   get loggedIn(): number {
   return (
     JSON.parse(localStorage.getItem("user")) ?
     JSON.parse(localStorage.getItem("user")).id : 0
   );
 }

    get allowedUser(){
    return (''+this.userType)=='90'
  }

  loadNotes(): void {
    this.isLoading = true;
    this.notesService.getNotes(this.roomId).subscribe((res:any) => { 
    this.isLoading = false;
      
      this.notes = res.sort((a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      this.notes.forEach(note=>{
        note.showreply_body = false;
        note.reply_body = '';
        note.showEditBox = false;
        note.author_name = note.author_name || 'Design Team';
        note.replies?.forEach((reply:any)=>{
          reply.author_name = reply.author_name || 'Design Team';
        });
      }) 
        this.isLoading = false;
    },() => {
      this.isLoading = false;
    });
  }

  showReply(index:number){
    this.notes[index].showreply_body = !this.notes[index].showreply_body;
  }

  addNote(): void {
    if (!this.noteBody.trim()) {
      return;
    }

    this.isSubmitting = true;

    const payload = {
      room_id: this.roomId,
      note_body: this.noteBody.trim(),
      is_private: this.isPrivate ? 1 : 0
    };

    this.notesService.createNote(payload).subscribe(() => {
      this.noteBody = '';
      this.isPrivate = false; // reset to default
      this.isSubmitting = false;
      this.snackbar.open('Note added successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }



  editNote(note:any){
    note.showEditBox = true;
    this.noteId = note.note_id;
    // this.noteBody = note.note_body;
    // this.isPrivate = note.is_private === 1;

  //  this.scrollTop.emit();
  }
  
 

  updateNote(note:any){
       if (!note.note_body.trim()) {
      return;
    }

    this.isSubmitting = true;

    const payload = { 
      note_body: note.note_body.trim(),
      is_private: note.is_private ? 1 : 0
    };

    this.notesService.updateNote(this.noteId, payload).subscribe(() => {
      this.noteId = null;
      this.noteBody = ''; 
      this.isSubmitting = false;
      this.snackbar.open('Note updated successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }

  archiveNote(noteId:number){
    const payload = { 
      is_archived: 1
    };
    this.notesService.archiveNote(noteId, payload).subscribe(() => { 
      this.snackbar.open('Note archived successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }
  restoreNote(noteId:number){
    const payload = { 
      is_archived: 0
    };
    this.notesService.archiveNote(noteId, payload).subscribe(() => { 
      this.snackbar.open('Note Restored successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }
  deleteNote(noteId:number){
    this.notesService.deleteNote(noteId).subscribe(() => { 
      this.snackbar.open('Note deleted successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
}



  addReply(note:any){
    if (!note.reply_body.trim()) {
      return;
    }

    this.isSubmitting = true;

    const payload = { 
      reply_body: note.reply_body.trim()
    };

    this.notesService.replyNote(payload, note.note_id).subscribe(() => {
      note.reply_body = '';
      note.showreply_body = false;
      this.isSubmitting = false;
      this.snackbar.open('Reply added successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }
replyId:number|null = null;
  editReply(reply:any,index:number, subindex:number){
    this.notes.forEach(f=>{
      f.reply_body = '';
      f.showreply_body = false;
    });
    this.notes[index].showreply_body = true;
    this.notes[index].reply_body = reply.reply_body;
    this.replyId = reply.reply_id;
  }

  updateReply(note:any){
          if (!note.reply_body.trim()) {
      return;
    }

    this.isSubmitting = true;

    const payload = { 
      reply_body: note.reply_body.trim()
    };

    this.notesService.updateReply(payload, this.replyId).subscribe(() => {
      note.reply_body = '';
      note.showreply_body = false;
      this.isSubmitting = false;
      this.snackbar.open('Reply added successfully','x',{duration:3000});
      this.loadNotes();
      this.replyId = null;
    }, () => {
      this.isSubmitting = false;
    });
  }


  decideReplyFn(note:any){
    if(this.replyId){
      this.updateReply(note);
    }else{
      this.addReply(note);
    }
  }


  deleteReply(replyId:number){
    this.notesService.deleteReply(replyId).subscribe(() => { 
      this.snackbar.open('Reply deleted successfully','x',{duration:3000});
      this.loadNotes();
    }, () => {
      this.isSubmitting = false;
    });
  }
}